<template>
  <div class="favourites d-flex">
    <b-button v-if="itemId" variant="link" class="" @click="openFavouriteModal(0)">
      Save <span class="small"><b-icon icon="heart"></b-icon></span>
    </b-button>

    <b-modal
      :ref="'favourite-modal-' + itemId"
      size="lg"
      title="Save searches and favourites"
      hide-footer
    >
      <b-spinner v-if="loading" label="Spinning"></b-spinner>
      <b-tabs v-if="logged === true" v-model="tabIndex" content-class="mt-3">
        <b-tab :disabled="!itemId" title="Add to favourite list" class="p-3">
          <h5 class="mb-1">Select a list to add service to:</h5>
          <p class="mb-0">You can also create a new list using the 'create new list' tab above.</p>
          <p class="small">
            Note: after creating a new list you will still need to add the service to it.
          </p>
          <select v-model="itemListToAdd" class="custom-select my-2">
            <option
              v-if="userFavouriteLists.length < 1"
              default
              selected="selected"
              :value="'myFirstList'"
            >
              My first list
            </option>
            <option v-for="(list, index) in userFavouriteLists" :key="index" :value="list.id">
              {{ list.title }}
            </option>
          </select>
          <b-button variant="primary" @click.stop.prevent="addListItem()">Add</b-button>
        </b-tab>

        <b-tab title="Create new list" class="p-3">
          <h5 class="mb-4">Create favourite list</h5>
          <b-form-input v-model="title" placeholder="List name"></b-form-input>
          <b-button
            variant="outline-primary"
            size="sm"
            class="mt-2"
            @click.stop.prevent="createFavouriteList(title)"
            >Create list</b-button
          >
        </b-tab>
      </b-tabs>
      <span v-if="logged === false">
        <a href="/login" aria-label="Link to login form" itemprop="url">Login</a>
        or
        <a href="/register" aria-label="Link to registration form" itemprop="url">register</a>
        to save searches and create favourite lists.
      </span>
    </b-modal>
  </div>
</template>
<script>
import toast from '@/services/toast'
import slugg from '@/filters/sluggify.js'
import { FavouriteCall } from '@/common/api.service'

export default {
  name: 'FavouritePopUp',
  filters: {
    slugg,
  },
  props: {
    itemId: {
      type: String,
      default: '',
    },
    itemName: {
      type: String,
      default: '',
    },
    saveOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      userFavouriteLists: [{ id: false, title: '' }],
      selectedFavouriteList: [],
      itemFavouriteLists: [],
      title: '',
      addStatus: {},
      itemListToAdd: '',
      itemList: false,
      tabIndex: 0,
    }
  },
  computed: {
    logged() {
      return document.body.classList.contains('logged-in')
    },
    listsItemIsIn() {
      let listIds = this.itemFavouriteLists.map(({ list_id }) => list_id)
      let inLists = this.userFavouriteLists.filter((list) => listIds.includes(list.id))
      return inLists
    },
    selectedFavouriteListDetails() {
      let details = this.userFavouriteLists.filter((list) => list.id == this.itemList)
      if (details.length > 0) return details
      return [{ id: false, title: '' }]
    },
  },
  methods: {
    openFavouriteModal(tabId) {
      if (this.logged === true) {
        this.getUserFavouriteLists()
        this.itemListCheck(this.itemId)
      }
      this.$refs['favourite-modal-' + this.itemId].show()
      //if (viewList == true) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.tabIndex = tabId
          })
        })
      })
      //}
    },

    // Get the lists that an list item is in.
    async itemListCheck(id) {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_list_by_item',
        item_id: id,
      })
      this.itemFavouriteLists = data
      return
    },
    // Add item to list.
    async addListItem() {
      this.loading = true
      const { data } = await FavouriteCall.post({
        req_id: 'add_favourite_item',
        item_id: this.itemId,
        list_id: this.itemListToAdd,
        name: this.itemName,
      })
      this.loading = false
      this.wordpressLastErrorCheck('Item added to list', data)
      return
    },
    // Get all a users lists.
    async getUserFavouriteLists() {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_lists',
      })
      this.userFavouriteLists = data
    },
    // Get single list
    async getFavouriteList() {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_list_by_id',
        list_id: this.itemList,
      })
      this.selectedFavouriteList = data
    },
    // Create a list.
    async createFavouriteList(title) {
      this.loading = true
      const { data } = await FavouriteCall.post({
        req_id: 'create_user_favourite_list',
        title: title,
        description: '',
      })
      this.loading = false
      if (data.msg) return toast.warning(data.msg)
      if (data.find((item) => item.title == title)) toast.success('List created')
      return (this.userFavouriteLists = data)
    },
    async removeListItem(id, index) {
      const { data } = await FavouriteCall.post({
        req_id: 'remove_favourite_item',
        list_id: this.itemList,
        item_id: id,
      })
      console.log(data)
      this.favouriteList.splice(index, 1)
    },
    wordpressLastErrorCheck(message, data) {
      if (data.last_error == '') {
        this.itemListCheck(this.itemId)
        return toast.success(message)
      }
      if (data.last_error != '') {
        this.itemListCheck(this.itemId)
        return toast.error('Something went wrong.')
      }
    },
  },
}
</script>
